import { render, staticRenderFns } from "./tel-popup.vue?vue&type=template&id=2fd6eba9&"
import script from "./tel-popup.vue?vue&type=script&lang=js&"
export * from "./tel-popup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports